import React,{useEffect} from 'react'
import {TextField,Grid, Box,Button} from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { PartnerWithUsThreeSchema } from '../../Utils/Validations'

const PartnerWithUsThree = ({ handleBack, handleComplete, partnerWithUsData, setPartnerWithUsData }) => {
  const { handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(PartnerWithUsThreeSchema)
  })
  useEffect(() => {
    setValue("industry", partnerWithUsData.industry || "")
    setValue("other_industry", partnerWithUsData.other_industry || "")
  }, [])
  const onSubmit = (data) => {
    console.log(data)
    setPartnerWithUsData((prev) => ({ ...prev, industry: data.industry, other_industry: data.other_industry }))
    handleComplete()
  }
  return (
    <div>
        
        <Grid container  style={{justifyContent:"center",marginTop:20}} >
            <Grid sm={6} xs={12} sx={{textAlign:"left",paddingRight:{sm:1,xs:0}}} >
            <Controller
            control={control}
            name="industry"
            rules={{ required: true }}
            render={({ field }) => (
              <>
               <label>Industry</label>
                <TextField fullWidth placeholder='Industry'  {...field} error={errors.industry} helperText={errors?.industry?.message} />
              </>
            )}
          />
               
       
        
        </Grid>
        <Grid sm={6} xs={12} sx={{textAlign:"left",paddingLeft:{sm:1,xs:0},marginTop:{sm:0,xs:2}}}>
        <Controller
            control={control}
            name="other_industry"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <label>Other Industries</label>
                <TextField fullWidth placeholder="Other Industries" {...field} error={errors.other_industry} helperText={errors?.other_industry?.message} />

              </>
            )}
          />
       
        
        </Grid>
        </Grid>
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          Next
        </Button>

      </Box>
    </div>
  )
}

export default PartnerWithUsThree